class PromoPopup extends HTMLElement {
  constructor() {
    super();
    this.id = this.dataset.section;
    this.isEditor = !!(window.Shopify && window.Shopify.designMode);
    const delay = this.isEditor ? 0 : parseInt(`${this.dataset.delay}000`);
    const frequency = parseInt(this.dataset.frequency);
    this.date = this.dataset.timer;
    let show = this.isEditor;

    if (!this.isEditor) {
      if (localStorage.getItem('cs-promo-popup') === '' || localStorage.getItem('cs-promo-popup') === null || localStorage.getItem('cs-promo-popup') === undefined) {
        show = true;
      } else {
        let checkTime = new Date(this.date) - new Date(localStorage.getItem('cs-promo-popup'));
        const tamp = checkTime % 1000;
        checkTime = (checkTime - tamp) / 1000;
        const days = Math.floor(checkTime / 86400);
        if (days > frequency) {
          show = true;
        }
      }
    }

    if (show) {
      setTimeout(() => {
        this.show();
      }, delay);
    }
  }

  show() {
    document.body.classList.add('modal-loading');
    this.classList.add('modal-open');
    this.close();
  }

  close() {
    document.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE' && this.classList.contains('modal-open')) this.onButtonClick(event)
    })

    this.querySelectorAll('[data-modal-close]').forEach(
      (action) => {
        action.addEventListener('click', this.onButtonClick.bind(this));
      }
    );

    this.querySelectorAll('.promo-popup__button, .promo-popup__media-link, .promo-popup__secondary-link').forEach(
      (cta) => {
        cta.addEventListener('click', this.onCtaClick.bind(this));
      }
    );
  }

  onCtaClick() {
    if (!this.isEditor) {
      localStorage.setItem('cs-promo-popup', this.date);
    }
    document.body.classList.remove('modal-loading');
    this.classList.remove('modal-open');
  }

  onButtonClick(event) {
    event.preventDefault();
    if (!this.isEditor) {
      localStorage.setItem('cs-promo-popup', this.date);
    }
    document.body.classList.remove('modal-loading');
    this.classList.remove('modal-open');
  }
}

customElements.define('promo-popup', PromoPopup);
